<template>
    <div class="c-join">
        <div class="head-box"><navBar :isNav2="true"></navBar></div>
        <div class="headheight"></div>
        <div class="content">
            <!-- banner -->
            <div class="banner-box" :style="'background-image: url(' + form.bannerObj.img + ')'" v-img="{ form: form.bannerObj, key: 'img' }">
                <div class="container1" @click.stop>
                    <div class="text-content  wow fadeInUp">
                        <p class="name pingFang-Bold font50" v-edit="{ form: form.bannerObj, key: 'title' }">{{ form.bannerObj.title }}</p>
                        <div class="text font26" v-edit="{ form: form.bannerObj, key: 'content' }">{{ form.bannerObj.content }}</div>
                        <div class="ftext" v-edit="{ form: form.bannerObj, key: 'smallContent' }">
                            {{ form.bannerObj.smallContent }}
                        </div>
                        <div @click="showToggle" class="cursor but but-blank but-blank-hover understand-details" type="primary" round>
                            <span v-edit="{ form: form.bannerObj, key: 'buttonContent' }">{{ form.bannerObj.buttonContent }}</span>
                            <span class="arrow el-icon-d-arrow-right"></span>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 我们的优势 -->
            <div class="cell-box cell-three ptb120">
                <div class="container1">
                    <div class=" wow fadeInUp">
                        <p class="box-title pingFang-Heavy font40" v-edit="{ form: form.firstObj, key: 'title' }">{{ form.firstObj.title }}</p>
                        <p class="tips pingFang-Regular font24" v-edit="{ form: form.firstObj, key: 'content' }">{{ form.firstObj.content }}</p>
                    </div>
                    <div class="square-box">
                        <div
                            class="square pointer wow fadeInUp  square-active"
                            v-for="(item, key) in form.firstObj.list"
                            :key="key"
                            @mouseenter="setClickAnimate($event, 'square', 'square-active')"
                        >
                            <div class="top-num">
                                <div class="num-b">
                                    <p class="num">{{ key + 1 }}</p>
                                </div>
                            </div>
                            <p class="square-title font26" v-edit="{ form: item, key: 'title' }">{{ item.title }}</p>
                            <div class="horizontal-line"><span class="el-icon-minus"></span></div>
                            <p class="text" v-edit="{ form: item, key: 'content' }">{{ item.content }}</p>
                            <div class="bottom-img"><img :src="item.img" v-img="{ form: item, key: 'img' }" /></div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 可提供数据采集服务的范畴 -->
            <div class="gatherbox-sec1 ptb120">
                <div class="bag">
                    <img :src="form.secoundObj.img" alt="" v-img="{ form: form.secoundObj, key: 'img' }" />
                </div>
                <div class="container1">
                    <div class="gatherbox_tit wow fadeInUp">
                        <div class="tit font40" v-edit="{ form: form.secoundObj, key: 'title' }">{{ form.secoundObj.title }}</div>
                        <div class="text font24" v-edit="{ form: form.secoundObj, key: 'content' }">{{ form.secoundObj.content }}</div>
                    </div>
                    <div class="cont">
                        <div class="item wow fadeInUp" v-for="(item, key) in form.secoundObj.list" :key="key">
                            <div class="list">
                                <div class="img">
                                    <img :src="item.img" style="min-height: 62px;" alt="" v-img="{ form: item, key: 'img' }" />
                                </div>
                                <div class="font">
                                    <div class="tit font26" v-edit="{ form: item, key: 'title' }">{{ item.title }}</div>
                                    <div class="text" v-edit="{ form: item, key: 'content' }">{{ item.content }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 标准服务流程 -->
            <div class="gatherbox-sec2 ptb120">
                <div class="container1">
                    <div class="gatherbox_tit wow fadeInUp">
                        <div class="tit font40" v-edit="{ form: form.thiredObj, key: 'title' }">{{ form.thiredObj.title }}</div>
                        <div class="text font24" v-edit="{ form: form.thiredObj, key: 'smallContent' }">{{ form.thiredObj.smallContent }}</div>
                    </div>
                    <div class="nav wow fadeInUp">
                        <div class="gatherbox2_nav swiper-container">
                            <div class="swiper-wrapper">
                                <div
                                    :class="index == flowindex ? 'swiper-slide on' : 'swiper-slide'"
                                    v-for="(item, index) in form.thiredObj.list"
                                    :key="index"
                                    @click="flowToggle(index)"
                                >
                                    <a href="javascript:;" class="item">
                                        <span>{{ item.name }}</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="cont wow fadeInUp">
                        <div :class="index == flowindex ? 'img on' : 'img'" v-for="(item, index) in form.thiredObj.list" :key="index" @click="flowToggle(index)">
                            <img :src="item.src" :alt="item.name" v-img="{ form: item, key: 'src' }" />
                        </div>
                    </div>
                </div>
            </div>
            <!-- 立即定制你的数据采集方案 -->
            <div class="gatherbox-sec3" :style="'background-image: url(' + form.fourthObj.img + ')'" v-img="{ form: form.fourthObj, key: 'img' }">
                <div class="container1" @click.stop>
                    <div class="cont">
                        <div class="tit" v-edit="{ form: form.fourthObj, key: 'title' }">{{ form.fourthObj.title }}</div>
                        <div @click="showToggle" class="but but-blank but-blank-hover understand-details" type="primary" round>
                            <span v-edit="{ form: form.fourthObj, key: 'buttonContent' }">{{ form.fourthObj.buttonContent }}</span>
                            <span class="arrow el-icon-d-arrow-right"></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <submit-form :form="form" :refComponentId="164" :id="139"></submit-form>
        <guidance :type="2" :show="show" @hiddenToggle="hiddenToggle"></guidance>
    </div>
</template>

<script>
import Swiper from 'swiper'; //  ES6 导入swiper js文件
import 'swiper/dist/css/swiper.min.css'; // ES6 导入swiper css文件
import navBar from '../../components/navBar.vue';
import { initWow } from '@/utils/wow';
import submitForm from '../../components/submit-form.vue';
import { pageQuery } from '@/api';
import Guidance from '@/components/guidance.vue';
export default {
    name: 'joinUs',
    data() {
        return {
            show: false,
            form: {
                // bannerObj: {
                //     img: require('../../assets/images/shuweishufbanner.jpg'),
                //     title: '数位数采',
                //     content: '已支撑1亿+采集任务的信息采集质检管理平台',
                //     smallContent: '依托数位7年积累的POI采集产品及运营能力，为客户量身定制线下数据采集解决方案及数据采集服务',
                //     buttonContent: '立即咨询',
                //     path: ''
                // },
                // firstObj: {
                //     title: '我们的优势',
                //     content: '七年沉淀积累，领先的采集技术和运营能力',
                //     list: [
                //         { img: require('../../assets/img/icon7.png'), title: '具备国家地理测绘资质', content: '可对线下物理空间进行合规信息采集' },
                //         { img: require('../../assets/img/icon8.png'), title: '七年积累的运营能力', content: '累计运营18万采集团队全国范围内可灵活调配的可靠的采集人员' },
                //         { img: require('../../assets/img/icon9.png'), title: '先进的数据采集系统', content: '可实现对采集任务及人员的智能化管理，并实现任务的智能派发' },
                //         { img: require('../../assets/img/icon10.png'), title: '领先的数据质保技术', content: '可实现复杂线下空间数据结构的高质量采集（防作弊、自质检、自更新）' }
                //     ]
                // },
                // secoundObj: {
                //     title: '可提供数据采集服务的范畴',
                //     content: '文字描述文字描述文字描述文字描述文字描述文字描述文字描述',
                //     img: require('../../assets/images/tafimg1.jpg'),
                //     list: [
                //         {
                //             title: '地产信息采集服务',
                //             content: '提供线下住宅小区、购物中心，以及临街商铺等地产信息数据的采集服务。',
                //             img: require('../../assets/images/tfamogw1.png')
                //         },
                //         {
                //             title: '咨询与调研应用信息采集服务',
                //             content: '提供如人流动线、客流勘察、房屋分布等定制化线下信息数据采集服务。',
                //             img: require('../../assets/images/tfamogw2.png')
                //         },
                //         {
                //             title: '新零售&本地生活应用信息采集服务',
                //             content: '提供如餐饮、美发等生活类店铺、空置商铺、商场等定制化线下信息数据采集服务。',
                //             img: require('../../assets/images/tfamogw3.png')
                //         },
                //         {
                //             title: '智能AI应用信息采集服务',
                //             content: '提供指定物品、视频、语音、图片等服务于AI、AR需求的定制化线下信息数据采集服务。',
                //             img: require('../../assets/images/tfamogw4.png')
                //         }
                //     ]
                // },
                // thiredObj: {
                //     title: '标准服务流程',
                //     content: '文字描述文字描述文字描述文字描述文字描述文字描述文字描述',
                //     list: [
                //         {
                //             name: '服务流程',
                //             src: require('../../assets/images/flowimgf1.png')
                //         },
                //         {
                //             name: '采集实施流程',
                //             src: require('../../assets/images/flowimgf2.jpg')
                //         }
                //     ]
                // },
                // fourthObj: {
                //     img: require('../../assets/images/caijifangan1.jpg'),
                //     title: '立即定制你的数据采集方案',
                //     buttonContent: '立即咨询',
                //     path: ''
                // }
            },
            flowindex: 0
        };
    },
    created() {},
    mounted() {
        pageQuery({ componentId: '164', current: 1, size: 10 }).then(res => {
            this.form = JSON.parse(res.data.data[0].context);
            this.$nextTick(() => {
                initWow();
            });
            new Swiper('.banner-swiper', {
                slidesPerView: 1, // 同时展示几屏
                spaceBetween: 30, // 两屏之间的间隔
                loop: true, // 循环轮播
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                },
                navigation: {
                    nextEl: '.c-join2 .c-next',
                    prevEl: '.c-join2 .c-prev'
                }
            });
            var nwesbox1cont = new Swiper('.gatherbox2_nav', {
                observer: true, //开启动态检查器，监测swiper和slide
                observeParents: true, //监测Swiper 的祖/父元素
                slidesPerView: 'auto',
                // centerInsufficientSlides: true,
                autoplay: {
                    delay: 4000,
                    stopOnLastSlide: false,
                    disableOnInteraction: true
                }
            });
        });
    },
    computed: {},
    methods: {
        showToggle() {
            if (this.$store.state.token) return;
            this.show = true;
        },
        hiddenToggle() {
            this.show = false;
        },
        flowToggle(_in) {
            this.flowindex = _in;
        }
    },
    components: { navBar, submitForm, Guidance },
    beforeDestroy() {},
    watch: {}
};
</script>

<style scoped lang="less">
::v-deep .navBar-box {
    z-index: 100;
    background: #fff;
    .navbar .nav-link {
        color: #333333;
    }
    .navbar .right-box .el-dropdown-link,
    .navbar {
        color: #333;
    }
    .navbar .nav-link .arrow {
        background-image: url(../../assets/images/arrow-down2.svg);
    }
    .navbar .navbar-toggler .icon-caidan {
        color: #333;
    }
    .navbar .navbar-collapse {
        @media @max-sm {
            position: absolute;
            top: 80px;
            left: 0;
            width: 100%;
            padding: 0 20px;
            background: #fff;
            overflow: hidden;
        }
    }
    .left-box {
        @media @max-sm {
            display: flex;
            align-items: center;
            height: 60px;
        }
    }
}
.c-join {
    .head-box {
        width: 100%;
        height: 80px;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 90;
        background-color: #ffffff;
    }
    // banner
    .banner-box {
        width: 100%;
        height: 880px;
        box-sizing: border-box;
        padding: 80px 0 0 0;
        background-repeat: no-repeat;
        background-size: cover;
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        position: relative;
        @media @max-lg {
            height: 700px;
        }
        @media @max-md {
            height: 500px;
        }
        @media @max-xs {
            height: 100vw;
        }
        .text-content {
            text-align: center;
            color: #fff;
            .text {
                margin-top: 10px;
                @media @max-lg {
                    margin-top: 6px;
                }
            }
            .ftext {
                font-size: 16px;
                margin-top: 8px;
                @media @max-lg {
                    margin-top: 4px;
                    font-size: 14px;
                }
            }
            .but {
                margin-top: 44px;
                display: inline-block;
                color: #fff;
                background-color: #eb5405;
                padding: 16px 40px;
                font-size: 16px;
                border: none;
                border-radius: 35px;
                transition: all 0.3s;
                @media @max-xs {
                    margin-top: 20px;
                    padding: 10px 15px;
                }
            }
            .but-blank {
                border: thin solid #eb5405;
            }
        }
    }
    .cell-box {
        width: 100%;
        padding: 135px 0 112px 0;
        text-align: center;
        @media @max-xs {
            padding: 60px 0;
        }
        .box-title {
            color: #000;
            margin-bottom: 4px;
        }

        .tips {
            color: #5a6779;
            margin-bottom: 32px;
        }

        .module-box {
            width: 100%;
            display: flex;
            justify-content: center;
            flex-wrap: wrap;
            margin-bottom: -20px;
            .module {
                width: calc(33% - 26px);
                box-sizing: border-box;
                border-radius: 8px;
                margin-bottom: 40px !important;
                @media @max-sm {
                    width: calc(50% - 20px);
                }
                @media @max-xs {
                    width: 100%;
                    margin-bottom: 20px !important;
                }
                .m-img {
                    width: calc(100% - 2px);
                    height: 265px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    background: url('../../assets/img/about_bg.png') no-repeat;
                    background-size: 100% 100%;
                    margin: 0 auto;
                    @media @max-lg {
                        height: 200px;
                    }
                    img {
                        width: 120px;
                        height: auto;
                        object-fit: scale-down;
                        @media @max-lg {
                            width: 80px;
                        }
                    }
                }

                .icon-img {
                    width: 380px;
                    height: auto;
                    object-fit: scale-down;
                }

                .module-title {
                    padding: 0 70px;
                    color: #000;
                    margin-bottom: 15px;
                    font-family: 'PingFang-Heavy';
                    transition: all 0.3s;
                    @media @max-lg {
                        padding: 0 50px;
                    }
                    @media @max-xs {
                        padding: 0 40px;
                    }
                }

                .text {
                    min-height: 100px;
                    padding: 0 70px 90px;
                    color: #65697f;
                    word-break: break-all;
                    text-align: left;
                    @media @max-bg {
                        min-height: auto;
                    }
                    @media @max-lg {
                        padding: 0 50px 70px;
                    }
                    @media @max-xs {
                        padding: 0 40px 60px;
                    }
                }
            }

            .module-img-b {
                background: url('../../assets/img/cellb.png') no-repeat;
                background-size: 100% 100%;
                border: thin solid #fff;
            }

            .module:nth-child(3n-1) {
                margin: 0 40px;
                @media @max-sm {
                    margin: 0;
                }
            }
            .module:nth-child(2n) {
                @media @max-sm {
                    margin-left: 40px;
                }
                @media @max-xs {
                    margin-left: 0;
                }
            }

            .module-hover:hover {
                .module-title {
                    color: #eb5405;
                }

                .m-img {
                    img {
                        animation: moduleUp 1s ease forwards;
                    }
                }
            }
        }
    }
    .cell-three {
        .square-box {
            width: 100%;
            max-width: 1400px;
            min-height: 580px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            flex-wrap: wrap;
            text-align: left;
            margin-bottom: -20px;
            .square {
                width: calc(25% - 20px);
                box-sizing: border-box;
                border-radius: 8px;
                background: url('../../assets/img/cellb.png') no-repeat;
                background-size: 100% 100%;
                border: thin solid #fff;
                margin-bottom: 40px !important;
                transition: all 0.3s;
                height: 490px;
                @media @max-lg {
                    height: 430px;
                    width: calc(25% - 20px);
                }
                @media @max-md {
                    height: 430px;
                    width: calc(50% - 20px);
                }
                @media @max-xs {
                    height: 380px;
                    width: 100%;
                    margin-bottom: 20px !important;
                }
                .top-num {
                    width: 100%;
                    display: flex;
                    justify-content: flex-end;
                    align-items: center;

                    .num-b {
                        margin: -1px -1px 0 0;
                        width: 70px;
                        height: 70px;
                        background: url('../../assets/img/sjx2.png') no-repeat;
                        background-size: 100% 100%;
                        display: flex;
                        justify-content: center;

                        .num {
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            position: relative;
                            padding-bottom: 20px;
                            right: -2px;
                            width: 100%;
                            height: 100%;
                            font-family: 'numberFontH';
                            font-size: 50px;
                            color: #fff;
                            border-radius: 0 0 0 25px;
                            overflow: hidden;
                            text-align: center;
                            margin-top: 2px;
                            &::before {
                                content: '';
                                position: absolute;
                                top: 0;
                                left: 0;
                                width: 0;
                                height: 0;
                                border: 35px solid transparent;
                                border-left: 35px solid #f6f7fb;
                                border-bottom: 35px solid #f6f7fb;
                            }
                        }
                    }
                }

                .square-title {
                    width: 100%;
                    box-sizing: border-box;
                    color: #333333;
                    margin-top: 46px;
                    padding: 0 20px 0 36px;
                    font-family: 'PingFang-Heavy';
                    @media @max-lg {
                        padding: 0 32px;
                    }
                    @media @max-md {
                        padding: 0 20px;
                    }
                    @media @max-xs {
                        margin-top: 0;
                    }
                }

                .horizontal-line {
                    width: 100%;
                    box-sizing: border-box;
                    margin: 30px 0 9px 0;
                    padding: 0 20px 0 36px;
                    @media @max-lg {
                        margin-top: 30px;
                        padding: 0 32px;
                    }
                    @media @max-md {
                        padding: 0 20px;
                    }
                    .el-icon-minus {
                        font-size: 26px;
                        color: #eb5405;
                    }
                }

                .text {
                    height: 50px;
                    color: #65697f;
                    text-align: left;
                    padding: 0 20px 0 36px;
                    flex-shrink: 0;
                    font-family: 'PingFang-Medium';
                    @media @max-lg {
                        padding: 0 32px;
                    }
                    @media @max-md {
                        padding: 0 20px;
                    }
                }

                .bottom-img {
                    width: 100%;
                    box-sizing: border-box;
                    padding: 0 20px 0 36px;
                    display: flex;
                    justify-content: flex-end;
                    margin: 70px 0 52px 0;
                    @media @max-lg {
                        padding: 0 32px;
                        margin: 30px 0 50px 0;
                    }
                    @media @max-xs {
                    }
                    img {
                        width: auto;
                        height: 104px;
                        object-fit: scale-down;
                        @media @max-lg {
                            height: 80px;
                        }
                    }
                }
            }

            .square:last-child {
                margin: 0;
            }

            .square-active {
                height: 528px;
                @media @max-lg {
                    height: 490px;
                }
                @media @max-lg {
                    height: 470px;
                }
                @media @max-md {
                    height: 430px;
                }
                @media @max-xs {
                    height: 380px;
                }
                .num-b {
                    background: url('../../assets/img/sjx1.png') no-repeat !important;
                }
            }
        }
    }
}
</style>
